import React, { useState } from "react";
import "./agendamento.css";
import ListaAgendados from "./Lista-de-Agendamentos/listaAgendados";
import { Agendamento } from "../../../API/AgendarEvento";

function TelaTemporizacao() {
  const [grupoLuz, setGrupoLuz] = useState("Postes");
  const [inicioLuz, setInicioLuz] = useState("");
  const [fimLuz, setFimLuz] = useState("");
  const [onValueLuz, setOnValueLuz] = useState("ON");
  const [offValueLuz, setOffValueLuz] = useState("OFF");

  const [grupoExaustor, setGrupoExaustor] = useState("Exaustor 1 e 2");
  const [inicioExaustor, setInicioExaustor] = useState("");
  const [fimExaustor, setFimExaustor] = useState("");
  const [onValueExaustor, setOnValueExaustor] = useState("ON");
  const [offValueExaustor, setOffValueExaustor] = useState("OFF");

  const [refreshFlag, setRefreshFlag] = useState(false);

  const handleSelectChange = (e, setGrupo, setOnValue, setOffValue) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    setGrupo(e.target.value);
    setOnValue(selectedOption.getAttribute('data-on'));
    setOffValue(selectedOption.getAttribute('data-off'));
  };

  const temporizar = async () => {
    if ((grupoLuz === "" || inicioLuz === "" || fimLuz === "") && (grupoExaustor === "" || inicioExaustor === "" || fimExaustor === "")) {
      alert("Preencha todos os campos.");
      return;
    } else if (grupoLuz !== "" && inicioLuz !== "" && fimLuz !== "" && (grupoExaustor === "" || inicioExaustor === "" || fimExaustor === "")) {
      await Agendamento(grupoLuz, inicioLuz, fimLuz, onValueLuz, offValueLuz, "Iluminação");
      alert("Agendamento apenas de luzes salvo.");
      // Limpar os campos de luzes
      setInicioLuz("");
      setFimLuz("");
    } else if ((grupoLuz === "" || inicioLuz === "" || fimLuz === "") && grupoExaustor !== "" && inicioExaustor !== "" && fimExaustor !== "") {
      await Agendamento(grupoExaustor, inicioExaustor, fimExaustor, onValueExaustor, offValueExaustor, "exaustor");
      // Limpar os campos de exaustores
      setInicioExaustor("");
      setFimExaustor("");
    } else {
      await Agendamento(grupoLuz, inicioLuz, fimLuz, onValueLuz, offValueLuz, "Iluminação");
      alert("Agendamento de luzes salvo.");
      // Limpar os campos de luzes
      setInicioLuz("");
      setFimLuz("");
  
      await Agendamento(grupoExaustor, inicioExaustor, fimExaustor, onValueExaustor, offValueExaustor, "exaustor");
      alert("Agendamento de exaustores salvo.");
      // Limpar os campos de exaustores
      setInicioExaustor("");
      setFimExaustor("");
    }
    // Alterna o valor de refreshFlag para forçar a re-renderização de ListaAgendados
    setRefreshFlag(!refreshFlag);
  };

  return (
    <div id="TelaTemporizacao-mobile">
      <div id="temporizacao-mobile">
        <h1>Agendamentos diários</h1>
        <div id="temporizacaoContent-mobile">
          <div id="temporizacaoContent1-mobile">
            <h2>Luzes</h2>
            <div id="temporizacaoContent1-1-mobile">
              Grupo
              <select id="selectGrupoLuz-mobile" onChange={(e) => handleSelectChange(e, setGrupoLuz, setOnValueLuz, setOffValueLuz)}>
              <option value="Circulação Serviço 1 da torre San Marino" data-on="1A10" data-off="1A00">
                  Circulação Serviço 1 San Marino
                </option>
                <option value="Circulação Serviço 2 da torre San Marino" data-on="1B10" data-off="1B00">
                Circulação Serviço 2 San Marino
                </option>
                <option value="Parede Hall Social da torre San Marino" data-on="1C10" data-off="1C00">
                  Parede Hall Social San Marino
                </option>
                <option value="Pendente Hall Social da torre San Marino" data-on="1D10" data-off="1D00">
                  Pendente Hall Social San Marino
                </option>
                <option value="Circulação intermediário da torre San Marino" data-on="1E10" data-off="1E00">
                Circulação intermediário San Marino
                </option>   
                <option value="Circulação Varanda da torre San Marino" data-on="1F10" data-off="1F00">
                Circulação Varanda San Marino
                </option>
                <option value="Pendente Hall Social da torre Positano" data-on="1G10" data-off="1G00">
                Pendente Hall Social Positano
                </option>
                <option value="Parede Hall Social da torre Positano" data-on="1H10" data-off="1H00">
                Parede Hall Social Positano
                </option>               
                <option value="Circulação Serviço da torre Positano" data-on="1I10" data-off="1I00">
                Circulação Serviço Positano
                </option>      
                <option value="Varanda térreo e Intermediário da torre Positano" data-on="1J10" data-off="1J00">
                Varanda térreo e Interm. Positano
                </option>
                <option value="Circulação intermediário da torre San Marino" data-on="1K10" data-off="1K00">
                Circulação intermediário San Marino
                </option>
                <option value="Jardim 1 Entrada" data-on="1L10" data-off="1L00">
                Jardim 1 Entrada
                </option>
                <option value="Jardim 2 Entrada" data-on="1M10" data-off="1M00">
                Jardim 2 Entrada
                </option>
                <option value="Escadaria de entrada" data-on="1N10" data-off="1N00">
                Escadaria de entrada
                </option>
                <option value="Poste Rua 1" data-on="1O10" data-off="1O00">
                Poste Rua 1
                </option>
                <option value="Poste Rua 2" data-on="1P10" data-off="1P00">
                Poste Rua 2
                </option>
                <option value="Floreira Térreo 1" data-on="1Q10" data-off="1Q00">
                Floreira Térreo 1
                </option>
                <option value="Floreira Térreo 2" data-on="1R10" data-off="1R00">
                Floreira Térreo 2
                </option>
                <option value="Floreira Piscina 1" data-on="1S10" data-off="1S00">
                Floreira Piscina 1
                </option>
                <option value="Floreira interna Piscina" data-on="1U10" data-off="1U00">
                Floreira interna Piscina
                </option>
                <option value="Piscina" data-on="1V10" data-off="1V00">
                Piscina
                </option>
                <option value="Perfil Muro Piscina" data-on="1W10" data-off="1W00">
                Perfil Muro Piscina
                </option>
                <option value="Poste Piscina" data-on="1X10" data-off="1X00">
                Poste Piscina
                </option>
                <option value="Floreira Piscina 3" data-on="1Z10" data-off="1Z00">
                Floreira Piscina 3
                </option>
                <option value="Floreira Piscina 4" data-on="1[00" data-off="1[00">
                Floreira Piscina 4
                </option>
                <option value="Floreira Piscina 5" data-on="1\\10" data-off="1\\00">
                Floreira Quadra 1
                </option>
                <option value="Floreira Quadra 2" data-on="1]10" data-off="1]00">
                Floreira Quadra 2
                </option>
                <option value="Pergolado" data-on="1^10" data-off="1^00">
                Pergolado
                </option>
                <option value="Quadra 1" data-on="1_10" data-off="1_00">
                Quadra 1
                </option>
                <option value="Quadra 2" data-on="1`10" data-off="1`00">
                Quadra 2
                </option>
                <option value="Jardim fundos 1" data-on="1a10" data-off="1a00">
                Jardim fundos 1
                </option>
                <option value="Jardim fundos 2" data-on="1b10" data-off="1b00">
                Jardim fundos 2
                </option>
                <option value="Escadarias Fundos" data-on="1c10" data-off="1c00">
                Escadarias Fundos
                </option>
                <option value="Jardim Garden Gourmet 1" data-on="????" data-off="????">
                Jardim Garden Gourmet 1
                </option>
                <option value="Jardim Garden Gourmet 2" data-on="????" data-off="????">
                Jardim Garden Gourmet 2
                </option>
                <option value="Floreira Garden Piscina" data-on="????" data-off="????">
                Floreira Garden Piscina
                </option>
                <option value="Piscina do Garden" data-on="????" data-off="????">
                Piscina do Garden
                </option>
                <option value="Postes Rua Fundos" data-on="????" data-off="????">
                Postes Rua Fundos
                </option>
                <option value="Poste Fundos 1" data-on="????" data-off="????">
                Poste Fundos 1
                </option>
                <option value="Perfil Muro Fitness" data-on="????" data-off="????">
                  Perfil Muro Fitness
                </option>
                {/* Outras opções */}
              </select>
              <label htmlFor="temporizacao1-mobile">Inicio</label>
              <input type="time" id="inicioLuz" name="temporizacao1" value={inicioLuz} onChange={(e) => setInicioLuz(e.target.value)} />
              <label htmlFor="temporizacao2-mobile">Fim</label>
              <input type="time" id="fimLuz" name="temporizacao2" value={fimLuz} onChange={(e) => setFimLuz(e.target.value)} />
            </div>
          </div>
          <div id="temporizacaoContent2-mobile">
            <h2>Exaustor</h2>
            <div id="temporizacaoContent2-1-mobile">
              Grupo
              <select id="selectGrupoExaustores-mobile" onChange={(e) => handleSelectChange(e, setGrupoExaustor, setOnValueExaustor, setOffValueExaustor)}>
                <option value="Exaustor 1 e 2" data-on="ON" data-off="OFF">
                  Exaustor 1 e 2
                </option>
                <option value="Exaustor 3 e 4" data-on="ON" data-off="OFF">
                  Exaustor 3 e 4
                </option>
                {/* Outras opções */}
              </select>
              <label htmlFor="temporizacao4-mobile">Inicio</label>
              <input type="time" id="inicioExaustor" name="temporizacao3" value={inicioExaustor} onChange={(e) => setInicioExaustor(e.target.value)} />
              <label htmlFor="temporizacao2-mobile">Fim</label>
              <input type="time" id="fimExaustor" name="temporizacao4" value={fimExaustor} onChange={(e) => setFimExaustor(e.target.value)} />
            </div>
          </div>
        </div>
        <button id="btnSalvar-mobile" onClick={temporizar}>
          Salvar
        </button>
      </div>
      <div id="Lista-agendados-mobile">
        <ListaAgendados refreshFlag={refreshFlag} />
      </div>
    </div>
  );
}

export default TelaTemporizacao;